export default __webpack_public_path__ + "static/media/pineapple-black.4582857d.svg";